/**
 * @desc orderToArs
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(params: any, options?: any) {
  return updateResponse(
    http(URL + `/backdoor/orderToArs`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
